export default "__VITE_ASSET__D8_luRV6__"